import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { StyleRules, withStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import BugReportIcon from '@material-ui/icons/BugReport';
import * as React from 'react';
import { errorLogger } from '..';
import { RefreshPageDialog } from '../layout/RefreshPageDialog';

interface IErrorBoundaryProps {}
interface IErrorBoundaryState {
  hasError: boolean;
  showRefreshDialog: boolean;
}

type styleTypes = 'iconStyle';
const style: StyleRules<styleTypes> = {
  iconStyle: { height: 90, width: 90, textAlign: 'center' }
};

type ErrorBoundaryProps = IErrorBoundaryProps & WithStyles<styleTypes>;
class ErrorBoundaryComponent extends React.Component<ErrorBoundaryProps, IErrorBoundaryState> {
  state: IErrorBoundaryState = {
    hasError: false,
    showRefreshDialog: false
  };

  componentDidCatch(e: Error, errorInfo: React.ErrorInfo) {
    if (e.message.includes('chunk') || e.message.includes(`Unexpected token '<'`)) {
      // a chunk failed to load, probably because a new app version came out
      // open the new version dialog and force a refresh
      this.setState({ hasError: false, showRefreshDialog: true });
    } else {
      this.setState({ hasError: true });
      errorLogger.sendError(e, { customData: [{ reactErrorInfo: errorInfo.componentStack }], tags: ['ErrorBoundary'] });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Paper>
          <Grid container spacing={2} wrap="nowrap">
            <Grid item>
              <BugReportIcon className={this.props.classes.iconStyle} color="error" />
            </Grid>
            <Grid item xs>
              <Typography variant="h5">There was a problem loading this page.</Typography>
              <Typography variant="subtitle1">
                Please refresh this page. If the problem persists please contact IT.
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      );
    } else if (this.state.showRefreshDialog) {
      return <RefreshPageDialog />;
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withStyles(style)(ErrorBoundaryComponent);
